import React from 'react'
import { FormattedMessage } from 'react-intl'


export const REWARD_COUNT = (count, level) => (
    <FormattedMessage
        id='command_center_reward.count'
        defaultMessage='{count} клановых резервов {level} уровня'
        values={{
            count,
            level,
        }}
    />
)



// WEBPACK FOOTER //
// ./containers/CommandCenterCard/components/Reward/constants.jsx